import styled from "styled-components";
import { mobile } from "../responsive";
import React from "react";
const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    url("https://blog.kakaocdn.net/dn/Jtfu4/btqJHa6l0y2/iZ7l0JjlXjPv1SPRiEajh1/img.jpg")
      ;
  background-size: cover;
  background-position: 0px -30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 40%;
  padding: 20px;
  background-color: white;
  box-shadow:0 12px 15px 0 rgba(0,0,0,.24),0 17px 50px 0 rgba(0,0,0,.19);
  ${mobile({ width: "75%" })}
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0px 0px;
  padding: 10px;
`;

const Agreement = styled.span`
  font-size: 12px;
  margin: 20px 0px;
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
`;

const Register = () => {
  return (
    <>
    <Container>
      <Wrapper>
        <Title>創立帳號</Title>
        <Form>
          <Input placeholder="使用者名子" />
          <Input placeholder="使用者綽號" />
          <Input placeholder="電話" />
          <Input placeholder="信箱" />
          <Input placeholder="密碼" />
          <Input placeholder="在確定一次密碼" />
          <Agreement>
            以上資訊會消保會的<b>個人資訊法</b>規定，只為該公司所用將不會外流出去如有法律疑慮可以訊問SamKO
          </Agreement>
          <Button>創立</Button>
        </Form>
      </Wrapper>
    </Container>
    </>
  );
};

export default Register;
